// src/sectors/pilates/sessions/components/calendar/CalendarHeaderRow.jsx
import React from 'react';
import { useTheme as useMuiTheme, alpha } from '@mui/material/styles';
import MDBox from 'components/MDBox';
import MDTypography from 'components/MDTypography';
import { DAY_LABELS } from '../../data/mockCalendarData';

export function CalendarHeaderRow({
  days = [],
  today,
  gridCols,
  stickyTop = 64, // ✅ hardcode yerine prop (standart)
}) {
  const theme = useMuiTheme();
  const isDark = theme.palette.mode === 'dark';

  const surface = isDark ? alpha('#fff', 0.06) : alpha('#0b1220', 0.03);
  const border = isDark ? alpha('#fff', 0.1) : alpha('#0b1220', 0.1);

  const todayBg = alpha(theme.palette.primary.main, isDark ? 0.22 : 0.14);
  const todayInset = `inset 0 2px 0 ${alpha(theme.palette.primary.main, 0.65)}`;

  const weekendTint = isDark ? alpha('#fff', 0.03) : alpha('#0b1220', 0.02);

  // ✅ tek satır taşma standardı
  const ellipsis1 = {
    minWidth: 0,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  };

  return (
    <MDBox
      sx={{
        position: 'sticky',
        top: `${stickyTop}px`,
        zIndex: 1200,

        display: 'grid',
        gridTemplateColumns: gridCols,

        background: surface,
        backdropFilter: 'blur(10px)',
        WebkitBackdropFilter: 'blur(10px)',
        borderBottom: `1px solid ${border}`,
        boxShadow: `0 6px 18px ${alpha('#000', isDark ? 0.35 : 0.1)}`,

        minWidth: 0,
        overflow: 'hidden',
      }}
    >
      {/* TIME COL */}
      <MDBox
        sx={{
          px: 1.15,
          py: 0.9,
          borderRight: `1px solid ${border}`,
          display: 'flex',
          alignItems: 'center',
          minWidth: 0,
        }}
      >
        <MDTypography
          variant="caption"
          sx={{ color: theme.palette.text.secondary, fontWeight: 900 }}
        >
          Saat
        </MDTypography>
      </MDBox>

      {days.map((day, i) => {
        const isToday = String(day) === String(today);
        const isWeekend = i >= 5;

        const dayLabel = DAY_LABELS?.[i] ?? `Gün ${i + 1}`;

        return (
          <MDBox
            key={day}
            sx={{
              px: 1.15, // ✅ biraz sıkı: dar ekranda daha stabil
              py: 0.9,
              width: '100%',
              minWidth: 0,

              borderRight: i === 6 ? 'none' : `1px solid ${border}`,
              background: isToday ? todayBg : isWeekend ? weekendTint : 'transparent',
              boxShadow: isToday ? todayInset : 'none',

              // ✅ içerik itişmesini önle
              overflow: 'hidden',
            }}
          >
            {/* 1. satır: gün adı + bugün pill */}
            <MDBox
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 0.7,
                minWidth: 0,
              }}
            >
              <MDTypography
                variant="button"
                fontWeight="bold"
                sx={{
                  ...ellipsis1,
                  lineHeight: 1.05,
                  fontSize: 13.6,
                }}
                title={dayLabel}
              >
                {dayLabel}
              </MDTypography>

              {isToday ? (
                <MDBox
                  component="span"
                  sx={{
                    marginLeft: 'auto',
                    flex: '0 0 auto',

                    px: 0.85,
                    py: 0.28,
                    borderRadius: '999px',

                    fontWeight: 900,
                    fontSize: 11.2,
                    lineHeight: 1,

                    color: theme.palette.primary.main,
                    background: alpha(theme.palette.primary.main, isDark ? 0.16 : 0.1),
                    border: `1px solid ${alpha(theme.palette.primary.main, isDark ? 0.28 : 0.2)}`,
                    whiteSpace: 'nowrap',
                  }}
                >
                  bugün
                </MDBox>
              ) : null}
            </MDBox>

            {/* 2. satır: tarih */}
            <MDTypography
              variant="caption"
              sx={{
                ...ellipsis1,
                color: theme.palette.text.secondary,
                display: 'block',
                mt: 0.25,
                fontSize: 12,
                lineHeight: 1.1,
              }}
              title={String(day)}
            >
              {day}
            </MDTypography>
          </MDBox>
        );
      })}
    </MDBox>
  );
}
